import { Controller } from "stimulus"
import Rails from '@rails/ujs'

export default class extends Controller {
  static targets = [ "checkbox" ]

  connect () {
    let inputs
    this.checkboxTargets.forEach(el => {
      if (!el.checked) {
        if (el.value == 'Cargador') {
          inputs = document.querySelectorAll(
            '.se-input-cs, .se-input-k, .se-input-ki, .se-input-kd'
          )
        } else if (el.value == 'Izquierda') {
          inputs = document.getElementsByClassName('se-input-cli')
        } else if (el.value == 'Derecha') {
          inputs = document.getElementsByClassName('se-input-cld')
        }
        Array.from(inputs).forEach(el => {
          el.classList.add('d-none')
        })
      }
    })
  }

  fetchDiagram () {
    let ajustes = []
    this.checkboxTargets.forEach(el => {
      if (el.checked) {
        ajustes.push(el.value)
      }
    })
    // used only in seccionals
    const showPisoAltura = document.getElementById('piso-terminado-section')
                            ? document.getElementById('piso-terminado-section').querySelector('input[type="radio"]:checked').value == 'false'
                            : false
    Rails.ajax({
      url: this.data.get('url'),
      type: 'GET',
      data: `ajustes=${ajustes};showPisoAltura=${showPisoAltura}`
    })
  }

  filterInput (event) {
    let inputs
    if (event.target.value == 'Cargador') {
      inputs = document.querySelectorAll(
        '.se-input-cs, .se-input-k, .se-input-ki, .se-input-kd'
      )
    } else if (event.target.value == 'Izquierda') {
      inputs = document.getElementsByClassName('se-input-cli')
    } else if (event.target.value == 'Derecha') {
      inputs = document.getElementsByClassName('se-input-cld')
    }
    if (event.target.checked) {
      Array.from(inputs).forEach(el => {
        el.classList.remove('d-none')
      })
    } else {
      Array.from(inputs).forEach(el => {
        el.classList.add('d-none')
      })
    }
  }
}
